import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { useApi } from '../../hooks/useApi';
import TableWithPagination from "./../common/TableWithPagination";
import Modal from "./../common/Modal";

export default function Permisos() {
  const { get, post, put } = useApi();
  const [permisos, setPermisos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({ id: null, permiso: "", clave: "", descripcion: "", modulo: "" });

  // 🚀 Cargar permisos
  const fetchPermisos = async () => {
    setLoading(true);
    const data = await get('ListaPermisos');
    setPermisos(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchPermisos();
  }, []);

  const handleClose = () => {
    setModalOpen(false);
        setForm({
            id: null,
            nombre: "",
            descripcion: "",
            modulo: ""
        });
    };

  // 📝 Guardar (crear o editar)
  const handleSave = async () => {
  try {
    // 🚀 siempre usamos POST y enviamos id si existe
    await post('ActualizaPermisos', {
      id: form.id || 0,                  
      NamePermission: form.nombre,
      Description: form.descripcion,
      Modulo: form.modulo,
    });

    setModalOpen(false);                 
    setForm({                            
      id: null,
      permiso: "",
      descripcion: "",
      modulo: "",
    });
    fetchPermisos();                     
  } catch (error) {
    console.error('Error al guardar permiso:', error);
  }
};


  const onEdit = (permiso) => {
    console.log('Editando permiso:', permiso);
    setForm({
        id: permiso.id,
        nombre: permiso.namePermission,
        descripcion: permiso.description,
        modulo: permiso.modulo || "", // si tienes el campo modulo
    });
    setModalOpen(true); // abre el modal
    };

  // ❌ Eliminar
  const handleDelete = async (id) => {
    if (!window.confirm("¿Seguro que quieres eliminar este permiso?")) return;
    await fetch(`/api/permisos/${id}`, { method: "DELETE" });
    fetchPermisos();
  };

  // 📊 Columnas de la tabla
  const columns = [
    { header: "Modulo", accessor: "modulo" },
    { header: "Permiso", accessor: "namePermission" },
    { header: "Descripción", accessor: "description" },
  ];

  return (
    <div className="p-4">
        <div className="flex justify-between items-center pb-2 ">
            <h1 className="text-lg font-bold text-gray-700">Gestión de permisos</h1>
            <button 
                onClick={() => {
                    setForm({ id: null, nombre: "", clave: "", descripcion: "", modulo: "" }); // reset
                    setModalOpen(true); // abrir modal
                }}
                className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" >
            <Icon icon="mdi:plus" className="mr-2" /> Nuevo Permiso
            </button>
        </div>
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="p-4">
                <TableWithPagination
                    data={permisos}
                    columns={columns}
                    loading={loading}
                    onEdit={onEdit}
                    showView={false}
                    showEdit={true}
                    showDelete={true}
                />
            </div>
        </div>

      {/* 👇 Tu modal reutilizable */}
      <Modal show={modalOpen} onClose={() => setModalOpen(false)} title={form.id ? "Editar Permiso" : "Nuevo Permiso"}>
        <div className="space-y-3">
            <select className="w-full border p-2 rounded"
            value={form.modulo}
            onChange={(e) => setForm({ ...form, modulo: e.target.value })}
            >
              <option value="">Selecciona un módulo</option>
              <option value="Usuarios">Usuarios</option>
              <option value="Roles">Roles</option>
              <option value="Permisos">Permisos</option>
              <option value="Configuracion">Configuracion</option>
              <option value="Maximos">Maximos</option>
              <option value="Results">Results</option>
              <option value="HUB App">HUB App</option>
              <option value="HUB Aut">HUB Aut</option>
            </select>
          <input
            type="text"
            name="nombre"
            placeholder="Modulo.permiso"
            value={form.nombre}
            onChange={(e) => setForm({ ...form, nombre: e.target.value })}
            className="w-full border p-2 rounded"
          />
          <textarea
            name="descripcion"
            placeholder="Descripción"
            value={form.descripcion}
            onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
            className="w-full border p-2 rounded"
          />
        </div>

    
        <div className="flex justify-end gap-2">
            <button
            onClick={() => setModalOpen(false)}
            className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
            >
            Cancelar
            </button>
            <button
            onClick={handleSave}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2"
            >
            <Icon icon="mdi:content-save" />
            Guardar
            </button>
        </div>
      </Modal>
    </div>
  );
}
